import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const WorkspaceContext = createContext(null);

export function WorkspaceProvider({ children }) {
  const { user } = useAuth();
  const [workspaces, setWorkspaces] = useState([]);
  const [currentWorkspaceId, setCurrentWorkspaceId] = useState(null);
  const [members, setMembers] = useState([]);

  useEffect(() => {
    if (!user) {
      setWorkspaces([]);
      setMembers([]);
      setCurrentWorkspaceId(null);
      return;
    }
    api.get("/workspaces").then((r) => {
      setWorkspaces(r.data);
      const validIds = r.data.map((w) => w.id);
      const stored = localStorage.getItem("tw_workspace");
      if (stored && validIds.includes(stored)) {
        setCurrentWorkspaceId(stored);
      } else if (r.data.length) {
        setCurrentWorkspaceId(r.data[0].id);
      } else {
        setCurrentWorkspaceId(null);
        localStorage.removeItem("tw_workspace");
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    if (currentWorkspaceId) {
      localStorage.setItem("tw_workspace", currentWorkspaceId);
      api.get("/users", { params: { workspace_id: currentWorkspaceId } })
        .then((r) => setMembers(r.data))
        .catch(() => setMembers([]));
    } else {
      setMembers([]);
    }
  }, [currentWorkspaceId]);

  const current = workspaces.find((w) => w.id === currentWorkspaceId) || null;

  const refresh = async () => {
    const r = await api.get("/workspaces");
    setWorkspaces(r.data);
  };

  const memberById = (id) => members.find((m) => m.id === id);

  return (
    <WorkspaceContext.Provider value={{
      workspaces, current, currentWorkspaceId, setCurrentWorkspaceId,
      members, memberById, refresh,
    }}>
      {children}
    </WorkspaceContext.Provider>
  );
}

export const useWorkspace = () => useContext(WorkspaceContext);
